




































































































































































































































































































































































































import { mapState } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'
import InsurerFilter from '@/components/report/filters/Insurers.vue'
import StatusFilter from '@/components/report/filters/Status.vue'
import SubStatusFilter from '@/components/report/filters/SubStatus.vue'
import UpdatedFilter from '@/components/report/filters/Updated.vue'
import CreatedFilter from '@/components/report/filters/CreatedDate.vue'
import ReferenceDateFilter from '@/components/report/filters/ReferenceDate.vue'
import AdmissionDischargeFilter from '@/components/report/filters/AdmissionDischarge.vue'
import SelectPopover from '@/components/SelectPopover.vue'
import InputPopover from '@/components/InputPopover.vue'
import MemberFilter from '@/components/report/filters/Patient.vue'

@Component({
  components: {
    InsurerFilter,
    StatusFilter,
    SubStatusFilter,
    ReferenceDateFilter,
    UpdatedFilter,
    CreatedFilter,
    AdmissionDischargeFilter,
    SelectPopover,
    InputPopover,
    MemberFilter
  },
  computed: {
    ...mapState('gaps', ['users']),
    insurerFilterOn: function() {
      return this.$store.state.gaps.filter.report.insurerList.length ? true : false
    },
    statusFilterOn: function() {
      return this.$store.state.gaps.filter.report.statusList.length ? true : false
    },
    subStatusFilterOn: function() {
      return this.$store.state.gaps.filter.report.subStatusList.length ? true : false
    },
    admissionDischargeFilterOn: function() {
      return this.$store.state.gaps.filter.report.admissionDischargeList.length ? true : false
    },
    referenceDateFilterOn: function() {
      return this.$store.state.gaps.filter.report.referenceDate.from != null ||
        this.$store.state.gaps.filter.report.referenceDate.to != null
        ? true
        : false
    },
    ownerUserFilterOn: function() {
      return this.$store.state.gaps.filter.report.ownerUserList.length ? true : false
    },
    updatedFilterOn: function() {
      return this.$store.state.gaps.filter.report.updated.from != null ||
        this.$store.state.gaps.filter.report.updated.to != null
        ? true
        : false
    },
    createdFilterOn: function() {
      return this.$store.state.gaps.filter.report.createdDate.from != null ||
        this.$store.state.gaps.filter.report.createdDate.to != null
        ? true
        : false
    } /*
    memberIdFilterOn: function() {
      return this.$store.state.gaps.filter.report.memberId !=null ? true : false
    },
    memberFilterOn: function() {
      return this.$store.state.gaps.filter.report.firstName !=null || 
             this.$store.state.gaps.filter.report.lastName !=null || 
             this.$store.state.gaps.filter.report.gender !=null ||
             this.$store.state.gaps.filter.report.birthdateFrom !=null ||
             this.$store.state.gaps.filter.report.birthdateTo !=null? true : false
    },*/,
    memberIdFilterOn() {
      const { memberId } = this.$store.state.gaps.filter.report
      return memberId != null && memberId !== ''
    },
    memberFilterOn() {
      const { firstName, lastName, gender, birthdateFrom, birthdateTo } =
        this.$store.state.gaps?.filter?.report?.member || {}

      return [firstName, lastName, gender, birthdateFrom, birthdateTo].some(value => value != null && value !== '')
    }
  }
})
export default class MemberList extends Vue {
  @Prop(Array) readonly items!: Array<any>
  @Prop(Object) readonly filter!: Object

  lastShownFilter!: string
  showInsurerFilter = false
  showStatusFilter = false
  showSubStatusFilter = false
  showReferenceDateFilter = false
  showAdmisionDischargeFilter = false
  showUpdatedFilter = false
  showCreatedFilter = false
  showMemberFilter = false

  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter)
    }
    let show = false
    switch (filter) {
      case 'INSURER':
        show = !this.showInsurerFilter
        this.showInsurerFilter = show
        break
      case 'STATUS':
        show = !this.showStatusFilter
        this.showStatusFilter = show
        break
      case 'SUB-STATUS':
        show = !this.showSubStatusFilter
        this.showSubStatusFilter = show
        break
      case 'REFERENCE_DATE':
        show = !this.showReferenceDateFilter
        this.showReferenceDateFilter = show
        break
      case 'ADMISSION_DISCHARGE':
        show = !this.showAdmisionDischargeFilter
        this.showAdmisionDischargeFilter = show
        break
      case 'CREATED':
        show = !this.showCreatedFilter
        this.showCreatedFilter = show
        break
      case 'UPDATED':
        show = !this.showUpdatedFilter
        this.showUpdatedFilter = show
        break
      case 'MEMBER':
        show = !this.showMemberFilter
        this.showMemberFilter = show
        break
    }
    this.lastShownFilter = show ? filter : ''
  }

  setOwnerUserFilter(value: number[]) {
    //this.$store.commit("gaps/SET_OWNER_USER_FILTER", value);
    this.$store.state.gaps.filter.report.ownerUserList = value
  }

  search() {
    this.$emit('refresh')
  }

  setMemberIdFilter(value: string) {
    this.$store.state.gaps.filter.report.memberId = value
    this.search()
  }
}
